module.exports = __webpack_public_path__ + "img/GregMarks.84bf6480.png";